import { useState, useEffect, useRef } from "react";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html";
import { $getRoot, $insertNodes } from "lexical";
import { useDispatch } from "react-redux";
import {
  selectGeneral,
  setScrolledToTop,
} from "../../redux/slices/generalSlice";
import { useSelector } from "react-redux";
const HtmlPlugin = ({ initialHtml, onHtmlChanged }) => {
  const [editor] = useLexicalComposerContext();

  const [isFirstRender, setIsFirstRender] = useState(true);
  const isFirstRenderRef = useRef(true);
  const dispatch = useDispatch();
  const { isScrolledToTop } = useSelector(selectGeneral);
  useEffect(() => {
    if (!initialHtml || !isFirstRender || !isFirstRenderRef?.current) return;
    isFirstRenderRef.current = false;
    setIsFirstRender(false);
    editor.update(() => {
      const parser = new DOMParser();
      const dom = parser.parseFromString(initialHtml, "text/html");
      const nodes = $generateNodesFromDOM(editor, dom);
      $getRoot().select();
      $insertNodes(nodes);
      if (!isScrolledToTop && dom?.activeElement?.textContent?.length) {
        setTimeout(() => {
          window.scrollTo({ top: 0, left: 0 });
          dispatch(setScrolledToTop(true));
        }, 10);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialHtml, editor, isFirstRender, isScrolledToTop]);

  return (
    <OnChangePlugin
      onChange={(editorState) => {
        editorState.read(() => {
          onHtmlChanged($generateHtmlFromNodes(editor));
        });
      }}
    />
  );
};

export default HtmlPlugin;
